<template>
    <div class="sort-icons-wrapper">
        <img :src="upIconSrc" alt="Sort Ascending" class="sort-up-icon" />
        <img :src="downIconSrc" alt="Sort Descending" class="sort-down-icon" />
    </div>
</template>

<script>
export default {
    props: {
        columnKey: {
            type: String,
            required: true,
        },
        sortBy: {
            type: String,
            required: true,
        },
        sortDesc: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        isActive() {
            return this.sortBy === this.columnKey;
        },
        upIconSrc() {
            if (this.isActive && !this.sortDesc) {
                return "/media/images/sort-icon-active.svg";
            }
            return "/media/images/sort-icon.svg";
        },
        downIconSrc() {
            if (this.isActive && this.sortDesc) {
                return "/media/images/sort-icon-active.svg";
            }
            return "/media/images/sort-icon.svg";
        },
    },
};
</script>

<style scoped>
.sort-icons-wrapper {
    position: relative;
    flex-direction: column;
    vertical-align: middle;
    margin-left: 4px;
    line-height: 0.7;
}

.sort-up-icon {
    width: 8px;
    height: 8px;
    margin-bottom: 2px;
    position: absolute;
    top: -15px;
    right: 10px;
}

.sort-down-icon {
    width: 8px;
    height: 8px;
    transform: rotate(180deg);
    margin-bottom: 3px;
    position: absolute;
    top: -16px;
    right: 3px;
}
</style>
